

/**
 * Tries to preload an image.
 *
 * @param {string | Object} src - Source of the avatar.
 * @returns {Promise}
 */
export function preloadImage(src: string | Object): Promise<string> {
    const { isIconUrl } = require('./functions');

    if (isIconUrl(src)) {
        return Promise.resolve(src);
    }

    return new Promise((resolve, reject) => {
        const image = document.createElement('img');

        image.onload = () => resolve(src);
        image.onerror = () => reject(new Error(`Failed to load image at ${typeof src === 'string' ? src : 'object'}`));

        // $FlowExpectedError
        image.referrerPolicy = 'no-referrer';
        image.src = src;
    });
}
